import CustomerDetail from 'src/pages/Customers/CustomerDetail'
import Customers from 'src/pages/Customers/Customers.vue'
import CustomersForm from 'src/pages/Customers/CustomersForm.vue'
import CustomersIndex from 'src/pages/Customers/CustomersIndex.vue'
import Lamps from 'src/pages/Lamps/IndexLamps.vue'
import Tickets from 'src/pages/Tickets/TicketsIndex'

const path = 'customers'
const title = 'Clientes'
export default {
  path: path,
  component: Customers,
  children: [
    {
      path: '',
      name: `${path}.index`,
      component: CustomersIndex,
      meta: {
        title: title,
        requireAuth: true
      }
    },
    {
      path: 'create',
      name: `${path}.create`,
      component: CustomersForm,
      meta: {
        title: title,
        requireAuth: true
      }
    },
    {
      path: 'edit/:id',
      name: `${path}.edit`,
      component: CustomersForm,
      meta: {
        title: title,
        requireAuth: true
      }
    },
    {
      path: ':id/lamps',
      name: `${path}.lamps`,
      component: Lamps,
      meta: {
        title: 'Troca de Lâmpadas',
        requireAuth: true
      }
    },
    {
      path: ':id/tickets',
      name: `${path}.tickets`,
      component: Tickets,
      meta: {
        title: 'Ticket',
        requireAuth: true
      }
    },
    {
      path: 'details/:id',
      name: `customer.detail`,
      component: CustomerDetail,
      meta: {
        title: 'Detalhes do Cliente',
        requireAuth: true
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/customers.js